import { displayToastError, http } from 'app';

export interface TypeOfLossResponse {
  datasetId: string;
  preview: any[];
  totalRows: number;
  fileBase64: string;
}

export const processFileAndGetTypeOfLoss = async (
  businessArea: string,
  service: string,
  file: File,
  trainFile?: File
): Promise<TypeOfLossResponse> => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    if (trainFile) {
      formData.append('trainFile', trainFile);
    }

    const response = await http.post<TypeOfLossResponse>(
      '/:businessArea/:service'
        .replace(':businessArea', businessArea)
        .replace(':service', service),
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return {
      datasetId: response.data.datasetId,
      preview: response.data.preview,
      totalRows: response.data.totalRows,
      fileBase64: response.data.fileBase64
    };
  } catch (error: any) {
    const errorMessage = error.response?.data?.message || error.message;
    displayToastError(
      String(errorMessage),
      'Process file and get type of loss'
    );
    throw error;
  }
};
